import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { LocationState } from '../types';

import axiosInstance from '../../../../api/axiosInstance';
import query from '../../../../api/constants.api';
import { useAuthContext } from '../../../../contexts/AuthContext';


type TProps = {
    setShowFeedbackModal: (val: boolean) => void;
};
const useFollowIncident = ({ setShowFeedbackModal }: TProps) => {
    const { user } = useAuthContext();
    const { state } = useLocation() as LocationState;

    const followIncident = () => {
        const body = {
            watch_list: user.sys_id,
        };

        return axiosInstance('PUT', `${query.path.incident}/${state.incidentId}`, body, null, 'application/json');
    };

    return useQuery('follow-incident', followIncident, {
        enabled: false,
        onSuccess: () => setShowFeedbackModal(true),
        onError: () => setShowFeedbackModal(true),
    });
};

export default useFollowIncident;